import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ThemeProvider from './theme/ThemeProvider';
import { GlobalStyle } from './theme/GlobalStyles';
import HomePage from './pages/HomePage';
import RegistrationPage from './pages/RegistrationPage';
import CustomerDashboard from './pages/CustomerDashboard';
import VerifyCDE from './pages/VerifyCDE';
import TicketsHistory from './pages/TicketsHistory';
import ConfirmComplaintsResolution from './pages/ConfirmComplaintsResolution';
import ComplaintsPage from './pages/ComplaintsPage';
import ViewProductInformation from './pages/ViewProductInformation';
import ScanGreenTag from './pages/ScanGreenTag';
import AccessCustomerTraining from './pages/AccessCustomerTraining';
import TrainingPage from './pages/TrainingPage';
import DynamicServiceRequest from './pages/DynamicServiceRequest';
import FollowUpContestChat from './pages/FollowUpContestChat';
import { initIOSCompat } from './utils/iosCompat';
// import DebugPanel from './components/DebugPanel';
// import debugService from './services/debugService';

function App() {
  // Initialize iOS Safari compatibility fixes
  useEffect(() => {
    initIOSCompat();
  }, []);

  // Debug panel disabled
  // useEffect(() => {
  //   // Enable debug mode in development
  //   if (process.env.NODE_ENV === 'development') {
  //     debugService.enableDebugMode();
  //   }

  //   // Enable debug mode with keyboard shortcut (Ctrl+Shift+D)
  //   const handleKeyPress = (e: KeyboardEvent) => {
  //     if (e.ctrlKey && e.shiftKey && e.key === 'D') {
  //       if (debugService.isDebugModeEnabled()) {
  //         debugService.disableDebugMode();
  //         alert('Debug mode disabled');
  //       } else {
  //         debugService.enableDebugMode();
  //         alert('Debug mode enabled');
  //       }
  //       window.location.reload();
  //     }
  //   };

  //   window.addEventListener('keydown', handleKeyPress);
  //   return () => window.removeEventListener('keydown', handleKeyPress);
  // }, []);

  return (
    <ThemeProvider>
      <GlobalStyle />
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/register" element={<RegistrationPage />} />
            <Route path="/cde-verification" element={<DynamicServiceRequest />} />
            <Route path="/dashboard" element={<CustomerDashboard />} />
            <Route path="/service-request" element={<DynamicServiceRequest />} />
            <Route path="/raise-service-request" element={<DynamicServiceRequest />} />
            <Route path="/complaints" element={<DynamicServiceRequest />} />
            <Route path="/pullout-request" element={<DynamicServiceRequest />} />
            <Route path="/unit-relocation" element={<DynamicServiceRequest />} />
            <Route path="/water-sampling" element={<DynamicServiceRequest />} />
            <Route path="/dynamic-form/:formName" element={<DynamicServiceRequest />} />
            <Route path="/verify-cde" element={<VerifyCDE />} />
            <Route path="/tickets-history" element={<TicketsHistory />} />
            <Route path="/confirm-resolution" element={<ConfirmComplaintsResolution />} />
            <Route path="/my-complaints" element={<ComplaintsPage />} />
            <Route path="/product-info" element={<ViewProductInformation />} />
            <Route path="/scan-tag" element={<ScanGreenTag />} />
            <Route path="/training" element={<TrainingPage />} />
            <Route path="/followup-chat" element={<FollowUpContestChat />} />
            <Route path="/contest-chat" element={<FollowUpContestChat />} />
          </Routes>
          {/* Debug Panel - Disabled */}
          {/* <DebugPanel /> */}
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
